import { CareRecipientId } from "../care_recipient/CareRecipientId";
import { DateTime } from "../fundamental/DateTime";
import { CareCommentContent } from "./CareCommentContent";
import { CareCommentId } from "./CareCommentId";
import { CareCommentTitle } from "./CareCommentTitle";

const CareCommentType = Symbol();

export class CareComment {
    [CareCommentType]: any;
    readonly id: CareCommentId;
    readonly careRecipientId: CareRecipientId;
    readonly title: CareCommentTitle;
    readonly content: CareCommentContent;
    readonly createdTime: DateTime;
    readonly isRead: boolean;

    private constructor(
        id: CareCommentId,
        careRecipientId: CareRecipientId,
        title: CareCommentTitle,
        content: CareCommentContent,
        createdTime: DateTime,
        isRead: boolean
    ) {
        this.id = id;
        this.careRecipientId = careRecipientId;
        this.title = title;
        this.content = content;
        this.createdTime = createdTime;
        this.isRead = isRead;
    }

    static from(
        id: CareCommentId,
        careRecipientId: CareRecipientId,
        title: CareCommentTitle,
        content: CareCommentContent,
        createdTime: DateTime,
        isRead: boolean
    ): CareComment {
        return new CareComment(id, careRecipientId, title, content, createdTime, isRead);
    }
}

export type CareCommentJson = {
    id: string,
    careRecipientId: string,
    title: string,
    content: string,
    createdTime: string,
    isRead: boolean
};
